import { newDynamicPagePanelV4 as newDynamicPagePanelV4Def } from '@wix/wix-data-client-common/dist/esm/panels/panelDefs'
import { DIMENSIONS } from './consts'
import getPanelUrl from '@wix/wix-data-client-common/dist/esm/panels/getPanelUrl'

export default async ({ hostname, editorSdkProxy }, initialData) => {
  const { width, height } = DIMENSIONS
  return editorSdkProxy.editor.openModalPanel({
    url: await getPanelUrl({
      hostname,
      relativeUrl: newDynamicPagePanelV4Def.url,
      editorSdkProxy,
    }),
    width,
    height,
    shouldHideHeader: true,
    initialData,
  })
}
